module.exports = "/templates/user.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/user.html
// module id = 482
// module chunks = 0